import styled from '@emotion/styled'
import { LoadingButton, LoadingButtonProps } from '@mui/lab'
import { css } from '@mui/material'
import cx from 'classnames'
import { isNumber } from 'lodash'
import { forwardRef } from 'react'

import LoadingOverlay from './LoadingOverlay'

export interface ButtonProps extends LoadingButtonProps {
  hovered?: boolean
  loadingPercent?: number
}

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    { children, color = 'primary', hovered, loadingPercent, variant = 'outlined', ...props },
    ref
  ) => {
    return (
      <StyledButton
        className={cx(props.className, { 'Mui-hover': hovered })}
        color={color}
        ref={ref}
        {...props}
        variant={variant}
      >
        {children}

        {isNumber(loadingPercent) && (
          <LoadingOverlay
            color={color}
            sx={{ borderBottomLeftRadius: 2, borderTopLeftRadius: 2 }}
            value={loadingPercent}
          />
        )}
      </StyledButton>
    )
  }
)

const StyledButton = styled(LoadingButton)<ButtonProps>`
  position: relative;
  overflow: hidden;

  &.Mui-disabled .MuiSvgIcon-root {
    ${({ color, theme }) =>
      color !== 'inherit' &&
      css`
        color: ${theme.palette.grey[400]};
      `}
  }

  &.MuiButton-sizeSmall {
    line-height: 1.65;
  }

  &.MuiLoadingButton-loading .MuiSvgIcon-root {
    visibility: hidden;
  }
`

export default Button
